module.exports = __webpack_public_path__ + "img/1-lg.73b76ba3.jpg";